import { getAppConfig } from "@repo/app-config";

export const appConfig = getAppConfig(import.meta.env.MODE);
